import Vue from "vue";
import Router from "vue-router";
import VueSession from "vue-session";

// layout
import Login from "@/layouts/Login";
import LoginAdmin from "@/layouts/LoginAdmin";
import Dashboard from "@/layouts/Dashboard";

// views
import CreatePayment from "../src/views/CreatePayment.vue";
import CreatePaymentAdmin from "../src/views/CreatePaymentAdmin.vue";
import PaymentGenerator from "../src/views/PaymentGenerator.vue";
import HistoryPayment from "../src/views/HistoryPayment.vue";
import HistoryPaymentAdmin from "../src/views/HistoryPaymentAdmin.vue";
import AdminManagement from "./views/AdminManagement.vue";
import UserManagement from "./views/UserManagement.vue";
import ManageStore from "./views/ManageStore.vue";

import "./components/css/style.css";

Vue.use(Router);
Vue.use(VueSession);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    { path: "/", redirect: "/login" },
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/login-admin",
      name: "LoginAdmin",
      component: LoginAdmin,
    },
    {
      path: "/",
      name: "dashboard",
      component: Dashboard,
      children: [
        {
          path: "/admin/createPayment",
          name: "createPaymentAdmin",
          component: CreatePaymentAdmin,
        },
        {
          path: "/createPayment",
          name: "createPayment",
          component: CreatePayment,
        },
        {
          path: "/paymentGenerator",
          name: "paymentGenerator",
          component: PaymentGenerator,
        },
        {
          path: "/historyPayment",
          name: "historyPayment",
          component: HistoryPayment,
        },
        {
          path: "/admin/historyPaymentAdmin",
          name: "historyPaymentAdmin",
          component: HistoryPaymentAdmin,
        },
        {
          path: "/admin/management/admin",
          name: "adminmanagement",
          component: AdminManagement,
        },
        {
          path: "/admin/management/user",
          name: "userManagement",
          component: UserManagement,
        },
        {
          path: "/admin/manageStore",
          name: "manageStore",
          component: ManageStore,
        },
      ],
    },
  ],
});
